/** Umwandlung von Eingabewerten aus dem DOM: React Hook Form liefert bei Null-Defaults `null`. */
function asText(value: unknown): string | null {
  if (typeof value !== 'string') {
    return null;
  }

  const trimmed = value.trim();
  return trimmed === '' ? null : trimmed;
}

export function textOrNull(value: unknown): string | null {
  return asText(value);
}

export function textOrUndefined(value: unknown): string | undefined {
  return asText(value) ?? undefined;
}

export function normalizeDecimalInput(value: unknown): unknown {
  if (typeof value !== 'string') {
    return value;
  }
  return value
    .trim()
    .replace(',', '.')
    .replace(
      /^(-?)\.(\d+)$/u,
      (_match: string, sign: string, fraction: string) => `${sign}0.${fraction}`,
    )
    .replace(/^(-?\d+)\.$/u, '$1');
}

export function decimalOrNull(value: unknown): string | null {
  return textOrNull(normalizeDecimalInput(value));
}

export function decimalOrUndefined(value: unknown): string | undefined {
  return textOrUndefined(normalizeDecimalInput(value));
}

export function numberOrNull(value: unknown): number | null {
  if (typeof value === 'number') return value;
  const text = asText(value);
  return text === null ? null : Number(text);
}

export function numberOrUndefined(value: unknown): number | undefined {
  return numberOrNull(value) ?? undefined;
}

export function numberOrDefault(value: unknown, fallback: number): number {
  return numberOrNull(value) ?? fallback;
}
